module.exports = __webpack_public_path__ + "static/img/metal31.5108c27.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/metal31.jpg
// module id = Czld
// module chunks = 0